module.exports = __webpack_public_path__ + "assets/img/17_1062.356028fa.jpg";